/* globals wNumb */

import { initBootstrapSelect } from '../../Shared/js/vendor/deferred';

async function main() {
    var filtersPage = wo$('#search-filters-partial');
    var criteria;
    if (!filtersPage.length) return;

    await initBootstrapSelect();
    var phoneSearchFiltersController = {
        init: function (rebind) {
            criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
            phoneSearchFiltersController.registerNotifications();
            phoneSearchFiltersController.updateFilters(rebind);
            filtersPage.find('[data-tab]').click(function () {
                var tab = wo$(this).data('tab');
                var modal = wo$('#modal-finder-filters');
                modal.data('tab', tab);
                modal.modal('show');
            });
            var keywordSearchBox = filtersPage.find('#searchbox');
            keywordSearchBox.keypress(function (e) {
                if (e.which === 13) {
                    phoneSearchFiltersController.searchByKeyword(wo$(this).val());
                }
            });
            keywordSearchBox.keydown(function () {
                keywordSearchBox.removeClass('bg-blue-light');
            });
            filtersPage.find('#search-button').click(function (e) {
                e.preventDefault();
                phoneSearchFiltersController.searchByKeyword(keywordSearchBox.val());
            });
            keywordSearchBox.val(criteria.search);
            if (criteria.search) {
                keywordSearchBox.addClass('bg-blue-light');
            } else {
                keywordSearchBox.removeClass('bg-blue-light');
            }

            WhistleOut.applySelectPickersStyle(filtersPage);

            var phoneBrandsSelect = filtersPage.find('#phone-brand-dropdown');
            WhistleOut.applySelectPicker(phoneBrandsSelect);
            phoneBrandsSelect.selectpicker('val', criteria.brands);
            phoneBrandsSelect
                .parent('div')
                .off('hidden.bs.dropdown')
                .parent('div')
                .on('hidden.bs.dropdown', function () {
                    var brands = phoneBrandsSelect.selectpicker('val');
                    var totalCount = parseInt(phoneBrandsSelect.data('count'));
                    if (!brands || brands.length === totalCount) {
                        brands = [];
                        phoneBrandsSelect.selectpicker('val', brands);
                    }
                    if (JSON.stringify(brands) !== JSON.stringify(criteria.brands)) {
                        criteria.brands = brands;
                        if (!criteria.brands) criteria.brands = [];
                        WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                    }
                });

            var suppliersSelect = filtersPage.find('#suppliers-dropdown');
            WhistleOut.applySelectPicker(suppliersSelect);
            suppliersSelect.selectpicker('val', criteria.suppliers);
            suppliersSelect
                .parent('div')
                .off('hidden.bs.dropdown')
                .parent('div')
                .on('hidden.bs.dropdown', function () {
                    var suppliers = suppliersSelect.selectpicker('val');
                    var totalCount = parseInt(suppliersSelect.data('count'));
                    if (!suppliers || suppliers.length === totalCount) {
                        suppliers = [];
                        suppliersSelect.selectpicker('val', suppliers);
                    }
                    if (JSON.stringify(suppliers) !== JSON.stringify(criteria.suppliers)) {
                        criteria.suppliers = suppliers;
                        if (!criteria.suppliers) criteria.suppliers = [];
                        WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                    }
                });

            var phoneOperatingSystemsSelect = filtersPage.find('#phone-os-dropdown');
            WhistleOut.applySelectPicker(phoneOperatingSystemsSelect);
            phoneOperatingSystemsSelect.selectpicker('val', criteria.operatingSystems);
            phoneOperatingSystemsSelect
                .parent('div')
                .off('hidden.bs.dropdown')
                .parent('div')
                .on('hidden.bs.dropdown', function () {
                    var operatingSystems = phoneOperatingSystemsSelect.selectpicker('val');
                    var totalCount = parseInt(phoneOperatingSystemsSelect.data('count'));
                    if (!operatingSystems || operatingSystems.length === totalCount) {
                        operatingSystems = [];
                        phoneOperatingSystemsSelect.selectpicker('val', operatingSystems);
                    }
                    if (JSON.stringify(operatingSystems) !== JSON.stringify(criteria.operatingSystems)) {
                        criteria.operatingSystems = operatingSystems;
                        if (!criteria.operatingSystems) criteria.operatingSystems = [];
                        WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                    }
                });

            filtersPage
                .find('a[data-sort-expression]')
                .off('click')
                .on('click', function () {
                    var sortExpression = wo$(this).data('sort-expression');
                    var sortAscending = true;
                    var isAscending = wo$(this).data('sort-ascending');
                    if (isAscending === false || isAscending === 'False') sortAscending = false;
                    var sortButton = wo$(this).closest('.dropdown-menu').prev();
                    sortButton.data('selected-sort-ascending', isAscending);
                    sortButton.data('selected-sort-expression', sortExpression);
                    wo$(this).closest('.dropdown-menu').find('i.fa-check').remove();
                    wo$(this).append('<i class="fa fa-check"></i>');
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    criteria.sortExpression = sortExpression;
                    criteria.sortAscending = sortAscending;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Sort', criteria: criteria });
                });
        },

        searchByKeyword: function (keyword) {
            WhistleOut.startProgress('[data-results-container]', 0.1, 50);
            criteria.search = keyword;
            WhistleOut.notifications.fire('FilterChanged', { type: 'Keyword', criteria: criteria });
        },

        registerNotifications: function () {
            WhistleOut.notifications.add(function (notification) {
                if (notification === 'SearchResultsRendered') {
                    phoneSearchFiltersController.updateFilters(true);
                }
            });
        },
        updateFilters: function (rebind) {
            //var queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
            WhistleOut.createSlider(
                filtersPage.find('#data-slider'),
                filtersPage.find('#data-text'),
                criteria.dataSlider,
                wNumb({ decimals: 0 }),
                function (currentPeg) {
                    //queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                    criteria.minData = currentPeg.value;
                    WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                },
                rebind
            );
            WhistleOut.createSlider(
                filtersPage.find('#price-slider'),
                filtersPage.find('#price-text'),
                criteria.priceSlider,
                wNumb({ decimals: 0 }),
                function (currentPeg) {
                    //queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                    criteria.maxSpend = currentPeg.value;
                    WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                },
                rebind
            );
            WhistleOut.createSlider(
                filtersPage.find('#upfront-slider'),
                filtersPage.find('#upfront-text'),
                criteria.upfrontSlider,
                wNumb({ decimals: 0 }),
                function (currentPeg) {
                    //queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                    criteria.maxUpfront = currentPeg.value;
                    WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                },
                rebind
            );
        }
    };

    phoneSearchFiltersController.init(false);
    WhistleOut.notifications.add(function (notification) {
        if (notification === 'SearchResultsRendered') {
            phoneSearchFiltersController.init(true);
            filtersPage.find('[data-enable-when-ready]').removeAttr('disabled');
            wo$(window).resize();
        }
    });
}

WhistleOut.initModule(import.meta.url, main);
